import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import BusinessCheckNiudStatusBlockData from '../../../Models/Content/BusinessCheckNiudStatusBlockData';
import BusinessCheckNiudStatusMain from './BusinessCheckNiudStatusMain';

export default class BusinessCheckNiudStatusBlock extends EpiComponent<BusinessCheckNiudStatusBlockData> {
  public render(): null | ReactNode | ReactNodeArray {
    return (
      <div>
        <BusinessCheckNiudStatusMain context={this.getContext()} iContent={this.props.data} />
      </div>
    );
  }
}
